package com.neurobs.js.dom

import org.scalajs.dom.html.Div
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._

class CollapsibleBox private (title: String, props: CollapsibleBox.Properties, content: HTMLElement) {
	private val plus = span(style := "width: 2em", "+").render
	private val minus = span(style := "width: 2em", "-").render
	private val titleBox = span(title).render

	private val contentWrapper = div(style := "display: none").render
	contentWrapper.appendChild(content)
	contentWrapper.style.padding = props.contentPadding
	contentWrapper.style.background = props.contentBackgroundColor
	contentWrapper.style.color = props.contentColor
	contentWrapper.style.borderBottomLeftRadius = props.radiusSize
	contentWrapper.style.borderBottomRightRadius = props.radiusSize

	private val button = div(plus, minus, titleBox).render
	button.style.cursor = "pointer"
	button.style.padding = props.headerPadding
	button.style.color = props.headerColor
	button.style.borderTopLeftRadius = props.radiusSize
	button.style.borderTopRightRadius = props.radiusSize
	button.style.background = props.headerBackgroundColor
	props.headerFontSize.foreach(button.style.fontSize = _)

	private var headerBackgroundColor = props.headerBackgroundColor

	button.onclick = { _ => setVisible(!visible) }
	button.onmouseover = { _ => button.style.background = props.headerBackgroundColorHover }
	button.onmouseout = { _ => button.style.background = headerBackgroundColor }

	def setVisible(visible: Boolean): Unit = {
		minus.style.display = if (visible) "inline-block" else "none"
		plus.style.display = if (visible) "none" else "inline-block"
		contentWrapper.style.display = if (visible) "block" else "none"
		button.style.borderBottomLeftRadius = if (visible) "0" else props.radiusSize
		button.style.borderBottomRightRadius = if (visible) "0" else props.radiusSize
	}

	def visible: Boolean = contentWrapper.style.display == "block"

	def setHeaderBackgroundColor(color: String): Unit = {
		headerBackgroundColor = color
		button.onmouseout(null)
	}

	def setTitle(title: String): Unit = titleBox.innerHTML = title

	val container: Div = div(button, contentWrapper).render
}

object CollapsibleBox {
	case class Properties
	(
		headerFontSize: Option[String] = None,
		radiusSize: String = "5px",
		headerPadding: String = "0.5em",
		headerBackgroundColor: String = "MidnightBlue",
		headerBackgroundColorHover: String = "LightSkyBlue",
		headerColor: String = "white",
		contentPadding: String = "1em",
		contentBackgroundColor: String = "white",
		contentColor: String = "black"
	)

	def apply(title: String, content: HTMLElement, open: Boolean = false, props: Properties = Properties()): CollapsibleBox = {
		val box = new CollapsibleBox(title = title, content = content, props = props)
		box.setVisible(open)
		box
	}
}
